"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormColorPicker = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var FormField_1 = require("../FormField");
var __1 = require("../");
var ColorPickerCardWrapper = /** @class */ (function (_super) {
    __extends(ColorPickerCardWrapper, _super);
    function ColorPickerCardWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focus: false,
        };
        _this.handleColorPickerOnFocus = function (e) {
            _this.setState({ focus: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(e);
            }
        };
        _this.handleColorPickerOnBlur = function (e) {
            _this.setState({ focus: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(e);
            }
        };
        return _this;
    }
    ColorPickerCardWrapper.prototype.render = function () {
        var props = this.props;
        return (react_1.default.createElement(__1.Card, { sharp: true, className: classnames_1.default('ColorPicker__CardWrapper', { 'ColorPicker__CardWrapper--disabled': props.disabled }, { 'ColorPicker__CardWrapper--focus': this.state.focus }) },
            react_1.default.createElement(__1.CardSection, { className: "ColorPicker__CardSection" },
                react_1.default.createElement(__1.ColorPicker, __assign({}, props, { onFocus: this.handleColorPickerOnFocus, onBlur: this.handleColorPickerOnBlur })))));
    };
    return ColorPickerCardWrapper;
}(react_1.Component));
var FormColorPicker = function (_a) {
    var props = __rest(_a, []);
    return react_1.default.createElement(FormField_1.FormField, __assign({ control: ColorPickerCardWrapper }, props));
};
exports.FormColorPicker = FormColorPicker;
//# sourceMappingURL=FormColorPicker.js.map